import { confirmVirtualHelpDesk as confirmVH } from '@/api/passenger'

const confirm = (context, params) => {
  return confirmVH(params).then((response) => {
    return response
  })
}

export default {
  confirm
}
